import React from "react";
import { BottomRootMenu } from "./bottom-root-menu";

/** Used to know if it can be added in the bottom menu */
export function isBottomRootMenuSupported() {
	return true;
}

export function BottomRootMenuContainer() {
	return <BottomRootMenu />;
}
